import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "layout" }

import SideBar from '@/layouts/SideBar.vue';
import ContentsContainer from '@/layouts/ContentsContainer.vue';
import AppHeader from '@/layouts/AppHeader.vue';
import ContentsArea from '@/layouts/ContentsArea.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'BasicLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SideBar),
    _createVNode(ContentsContainer, null, {
      default: _withCtx(() => [
        _createVNode(AppHeader),
        _createVNode(_component_router_view, null, {
          default: _withCtx(() => [
            _createVNode(ContentsArea)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})